<template>
  <div class="addVideo">
    <div class="grouping" >
      <van-button v-for="(item, index) in tabbar"
                  :key="index" :name="index"
                  :class="['terminal-btn', { 'selected': activeKey === index }]"
                  icon="/static/images/etv-folder.png"
                  @click="onChange(index)">
        {{ truncatedName(item.name) }}
      </van-button>
    </div>
    <div class="full-name">
      <span>{{groupingName}}</span>
    </div>
    <div  id="materiallist" >
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="materiallist abcds">
        <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="$t('append_field.noMore') "
            @load="onLoad"
        >
      <div class="content">
        <div class="photo" :style="{
				height:width + 'px',
				width: width + 'px'
			}">
          <input type="file" ref="fileInput" @change="handleFileChange" style="display: none;" />
          <img class="up_loading"
               src="/static/images/program/updata.png"
               @click="handleClick"
               style="width: 100%; height: 100%;" />
        </div>
        <div class="materia-item" v-for="(item,index) in materialList" @click="getselevt(item.checked,index)"
             :key="index" :style="{
				height:width + 'px',
				width: width + 'px'
			}">
          <div class="checkbox">
            <van-checkbox v-model="item.checked"></van-checkbox>
          </div>
          <van-list style="width:100%;height: 80%">
            <img v-lazy="getUrl(item.videoViewUrl?item.videoViewUrl:item.screenshotUrl)" @error="errImg($event, item)" style="width: 100%;height: 100%;">
          </van-list>
          <span class="audit-name">{{ item.name }}</span>
        </div>
      </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="btns" >
      <van-button color="#FF5700" size="small" @click="close">{{$t('append_field.cancel')}}</van-button>
      <span>{{$t('append_field.selectedNumber')}} ({{number}})</span>
      <van-button color="#006EFF" size="small" @click="submits">{{$t('append_field.confirm')}}</van-button>
    </div>

    <van-dialog v-model="show2" :title="$t('append_field.Up')" :show-confirm-button="false">
      <div style="margin: 30px 0px">
        <div class="updata">
          <van-cell :title="$t('append_field.fileName')">
            <div class="updata-item">{{ fileName }}</div>
          </van-cell>
          <van-cell :title="$t('append_field.fileSize')">
            <div class="updata-item">{{ fileSize }}M</div>
          </van-cell>
          <van-cell :title="$t('append_field.uploadProgress')">
          </van-cell>
          <van-cell>
            <div class="updata-item-right">
              <van-progress :percentage="complete" pivot-color="#006EFF" stroke-width="4" style="width: 100%;"></van-progress>
            </div>
          </van-cell>
          <div class="updata-item">
            <label class="updata-item-left"></label>
            <div style="float: right;margin: 10px 16px 0 0">
              <van-button color="#FF5700" size="small" @click="cancel">{{$t('append_field.cancelAllUploads')}}</van-button>
            </div>
          </div>
        </div>
        <!-- -->
      </div>
    </van-dialog>
    <!-- 禁用上传弹窗   -->
    <van-dialog v-model="showUploadFileDialog" :title="$t('append_field.getUploadendTim')">
      <div class="dialog-content">
        <span>{{ uploadFileText }}</span>
        <span>{{ $t('append_field.getUploadstartTime_tip') }}</span>
      </div>
    </van-dialog>
    <van-overlay :show="loading_show" @click="loading_show = false">
      <div class="wrapper" @click.stop>
        <van-loading  size="40px" vertical >{{$t('append_field.loadinga')}}</van-loading>
      </div>
    </van-overlay>

  </div>
</template>

<script>
  import {Toast} from 'vant'
  import qs from 'qs'
  import axios from "axios"
  import {classifyFileTypes, fileTypeList} from "../utils/handleUpload";

  import {calculateFileMd5, checkFileSize, getFileSuffix} from "../utils";
  import uploadService from "../utils/upload.service";
  function parseDateTime(dateTimeStr) {
    return new Date(dateTimeStr)
  }
  export default {
    name: 'addVideo',
    data() {
      return {
        loading_show: false,
        width: 0,
        number: 0,
        selectImg: [],
        materia: [],
        tabbar: [],
        groupingName: '',
        activeKey: 0,
        materialList: [],
        allmaterialList: [],
        index: 0,
        isHasMore: true,
        isLoading: false,
        checked: '',
        id: 1,
        FolderIndex: 0,
        msg: this.$t('append_field.loadingb'),
        show2: false,
        complete: 0,
        source: null,//取消上传
        fileName: "",
        fileSize: 0,
        allowUpload:false,
        showUploadFileDialog:false,
        uploadFileText:'',
        totalNum: 0, // Total number of items from the API
        pageNum: 1, // Current page number
        pageSize: 40, // Number of items per page
        loading: false,
        finished: false,
        refreshing: false,
        uploadCancelled: false,// 判断取消上传的标识（包含 MD5 阶段）
        currentFileMd5: '', // 当前正在上传文件的 MD5，用于精确取消
      }
    },
    mounted() {
      this.selectImg = []
      this.width = document.getElementById('materiallist').clientWidth / 4 - 2
      this.getFolder(0)

    },
    methods: {
      errImg(event) {
        event.target.src = '/static/images/icon_loader_failed_braseas.png'; // 设置错误图片
      },
      getFolder(index) {
        this.msg = this.$t('append_field.loadingb')
        const p = new Promise((resolve, reject) => {
          this.$ajax.post('/etv/findAllOrOneFolder.json', qs.stringify({
            mtType: 'video',
            type: 'select',
            id: '',
            filterType:1
          })).then(res => {
            if (res.data.code === 0) {
              localStorage.setItem("lastSize",res.data.data.lastSize)
              resolve(res.data.data)
            } else {
              reject()
            }
          })
        })
        p.then(res => {
          this.tabbar = res.children
          this.groupingName = this.tabbar[index].name
          this.id = this.tabbar[index].mfId
        })
      },
      close() {
        this.$emit('close')
      },
      submits() {
        if (this.selectImg.length === 0) {
          Toast(this.$t('append_field.selectVideo'))
          return
        }
        this.$emit('setVideos', this.selectImg)
      },
      onChange(index) {
        if (this.activeKey !== index) { // 避免不必要的变更
          this.activeKey = index // 更新活动键
        }
        this.materialList = []
        this.groupingName = this.tabbar[index].name
        this.id = this.tabbar[index].mfId
        this.finished = false
        this.pageNum = 1
        this.selectImg = []
        this.onLoad()

        this.FolderIndex = index
      },
      truncatedName(fullName) {
        // 截断名称并确保括号内容完整显示
        const namePart = fullName.split(' (')[0]
        const infoPart = fullName.includes('(') ? `${fullName.slice(fullName.indexOf('('))}` : ''
        if (namePart.length  <= 4) {
          return fullName
        } else {
          return `${namePart.substring(0, 4)}...${infoPart}`
        }
      },

      getselevt(sele, index) {

        this.materialList[index].checked = !sele
        this.$set(this.materialList, index, this.materialList[index])
        if (this.selectImg.includes(this.materialList[index])) {
          let i = this.selectImg.indexOf(this.materialList[index])
          this.selectImg.splice(i, 1)
        } else {
          this.selectImg.push(this.materialList[index])
        }
        this.number = this.selectImg.length
      },
      // 点击 div 触发的事件
      async handleClick() {
        try {
          const isAllowed = await this.getUploadSet()
          if (isAllowed) {
            this.allowUpload = true
            // 手动触发文件选择对话框,ios需要用setTimeout强制触发
            setTimeout(() => {
              this.$refs.fileInput.click()
            }, 0)
          } else {
            this.allowUpload = false
          }
        } catch (error) {
          Toast(this.$t('append_field.getUploadSet_tip')) // 处理 AJAX 请求失败的情况
          this.allowUpload = false
        }
      },
      // 文件选择变化事件处理
      async handleFileChange(event) {
        const file = event.target.files[0]
        if (file) {
          const lastSize = localStorage.getItem("lastSize") // 获取剩余空间大小
          const fileSizeInMB = file.size / 1024 / 1024 // 计算文件大小（转换为MB）
          // 当私有化部署时，只允许上传pdf、xls、xlsx文件
          if (this.uploadType !== 2) {
            const suffix = getFileSuffix(file.name)
            const ext = '.' + suffix.toLowerCase()
            const fileCategory = classifyFileTypes(ext)

            // 仅对文档类型做白名单限制，图片/音视频不受此处影响
            if (fileCategory === 'doc') {
              const allowedDocTypes = [ '.pdf', '.xls', '.xlsx']
              if (!allowedDocTypes.includes(ext)) {
                Toast(this.$t('append_field.unsupportedFormat'))
                event.target.value = ''
                return false
              }
            }
          }
          if (!fileTypeList.includes(file.name.split('.').pop().toLowerCase())) {
            Toast(this.$t('append_field.unsupportedFormat'))
            event.target.value = ''
            return false
          }
          if (lastSize < fileSizeInMB) {
            // 如果文件大小超过剩余空间，显示提示信息
            const remainingSpace = lastSize // 剩余空间大小
            const message = this.$t('append_field.last_size') + ' ' + remainingSpace + 'MB' // 构造包含剩余空间大小的消息
            Toast(message, 'fail') // 显示提示
            event.target.value = ''
            return
          }
          if (fileSizeInMB < 38 / 1024 && ["png", "jpg", "jpeg", "gif"].includes(file.name.split('.').pop().toLowerCase())) {
            Toast(this.$t('append_field.file_less_38'))
            event.target.value = ''
            return false
          }


          if (!checkFileSize(file)) {
            const suffix = getFileSuffix(file.name)
            const type = '.' + suffix.toLowerCase()
            const fileType = classifyFileTypes(type)


            // 定义各类型文件大小限制（单位：字节）
            const sizeLimits = {
              image: 20 * 1024 * 1024,      // 20MB
              video: 4 * 1024 * 1024 * 1024, // 4GB
              audio: 20 * 1024 * 1024,       // 20MB
              doc: 100 * 1024 * 1024         // 100MB
            }
            const sizeLimitMB = fileType === 'video'
                ? '4GB'
                : `${sizeLimits[fileType] / (1024 * 1024)}MB`
            const fileTypeName = {
              image: this.$t('append_field.image'),
              video:  this.$t('append_field.control_video'),
              audio:  this.$t('append_field.audio'),
              doc:  this.$t('append_field.document'),
            }[fileType]
            Toast(`${fileTypeName}${ this.$t('append_field.file_size_exceed_skip')}${sizeLimitMB}`)
            event.target.value = ''
            return false
          }
          this.fileName = ""
          this.fileSize =""
          this.complete = 0
          /*判断是要本地上传方式*/
          this.fileName = file.name
          this.fileSize = (file.size / 1024 / 1024).toFixed(2)
          this.show2 = true
          this.taskId = null // 重置 taskId
          const MD5_PROGRESS_WEIGHT = 20 // MD5计算占整体进度的20%
          const UPLOAD_PROGRESS_WEIGHT = 70 // 实际上传占整体进度的80%

          // 开始前重置取消标记
          this.uploadCancelled = false
          await calculateFileMd5(file, (md5Percent) => {
            // 将MD5进度映射到整体进度的0-20%
            const totalProgress = Math.floor((md5Percent / 100) * MD5_PROGRESS_WEIGHT)
            // 检查对象是否存在
            if (totalProgress) {
              this.complete = totalProgress
            }
          })
          // 如果在计算 MD5 过程中用户点击了“取消上传”，此时直接结束，不再发起真正的上传请求
          if (this.uploadCancelled) {
            this.uploadCancelled = false
            this.show2 = false
            this.complete = 0
            return
          }
          const result = await uploadService.upload(file, 1,localStorage.getItem('token'), this.uploadType, {
            onProgress: (percent) => {
              const totalProgress = Math.floor(MD5_PROGRESS_WEIGHT + (percent / 100) * UPLOAD_PROGRESS_WEIGHT)

              this.complete = totalProgress

            }
          })
          if (result) {

            const fd = new FormData()
            fd.append("mfId", this.id)
            fd.append("fileId", result.result)


            let cancelToken = axios.CancelToken
            this.source = cancelToken.source()
            // 统一返回建议包含 fileId/url；此处沿用原有素材登记接口
            await this.$ajax({
              url: this.upFileUrl + "etv/uploadMaterial.json",
              method: "post",
              cancelToken: this.source.token,
              data: fd,


            }).then(res => {
              this.complete = 100
              event.target.value = ''
              if (res.data.code === 0) {
                this.$nextTick( ()=>{
                  this.handleUploadSuccess(res.data.msg)
                })
              } else {
                console.error('COS上传失败:', res.data.msg)
                this.handleUploadError('上传失败')
              }


            }).catch(() => {

              file.state = -1
              this.handleUploadError('上传失败')
              // 继续上传下一个文件

            })
          } else {
            file.state = -1 // 失败

            this.handleUploadError('上传失败')

          }
        }
      },
      handleUploadSuccess(){
        this.materialList = []

        this.pageNum = 1
        this.selectImg = []
        // 关闭上传弹窗
        this.show2 = false

        // 重置上传状态
        this.complete = 0
        this.taskId = null
        this.getFolder(this.FolderIndex)
        this.loading_show = true
        setTimeout(() => {
          this.loading_show = false
          this.onLoad()
        }, 2000);

      },
      handleUploadError() {
        // 关闭上传弹窗
        this.show2 = false
        this.complete = 0
        this.taskId = null
        // 显示错误信息（已经在工具函数中显示了Toast）
      },

      // 判断是否在禁用上传素材时间
      getUploadSet() {
        return new Promise((resolve, reject) => {
          this.$ajax.post('/etv/getUploadSet.json').then(res => {

            if (res.data.code === 0) {
              const currentTime = new Date() // 获取当前时间
              this.uploadType=res.data.data.uploadType //获取上传类型 上传类型 0-本地 1-cos上传*/
              const startTime = parseDateTime(res.data.data.startTime) // 解析接口返回的开始时间
              const endTime = parseDateTime(res.data.data.endTime) // 解析接口返回的结束时间
              const formattedStartTime = startTime.toLocaleString()// 格式化开始时间
              const formattedEndTime = endTime.toLocaleString() // 格式化结束时间
              // 检查当前时间是否在禁止上传的时间段内
              if (currentTime >= startTime && currentTime <= endTime) {
                this.showUploadFileDialog=true
                this.uploadFileText=`${formattedStartTime}—${formattedEndTime}`
                resolve(false) // 不允许上传
              } else {
                resolve(true) // 允许上传
              }
            } else {
              Toast(this.$t('append_field.getUploadSet_tip'))
              resolve(false) // 出现错误，不允许上传
            }
          }).catch(error => {
            reject(error) // AJAX 请求失败，传递错误
          })
        })
      },
      async cancel() {
        // 取消当前上传（支持本地直传 / COS / OSS / S3）
        try {
          // 标记为已取消，供 MD5 阶段以及后续逻辑判断
          this.uploadCancelled = true

          // 优先按文件 MD5 精确取消，内部会根据不同 uploadType 做对应处理
          if (this.currentFileMd5) {
            await uploadService.cancelUpload(this.currentFileMd5)
          } else {
            // 兜底：如果还没算出 MD5，就取消所有控制器
            uploadService.cancelAll()
          }

          // 取消 axios 请求（如果有）
          if (this.source) {
            this.source.cancel(this.$t('material.cancelUpload'))
          }

        } catch (error) {
          console.error('取消上传失败:', error)

        }
        // 重置状态
        this.taskId = null
        this.complete = 0
        this.show2 = false
        Toast(this.$t('append_field.cancelAllUploads'))
      },
      getUrl(url) {

        if (!url) {
          return '/static/images/icon_loader_failed_braseas.png'
        }
        const isHttpUrl = url.startsWith("http")
        if (isHttpUrl) {
          return url
        }
        // 如果不是 HTTP URL，拼接基础 URL 并返回
        return this.upFileUrl + url
      },
      onLoad() {
        if (this.materialList.length >= this.totalNum && this.pageNum !== 1) {
          this.finished = true;
          this.loading = false;
          return;
        }
        this.loading = true;
        this.getmaterial(this.id, this.pageNum)
      },
      onRefresh() {
        this.finished = false;
        this.pageNum = 1
        this.selectImg = []
        this.materialList = [];
        this.onLoad()
      },
      getmaterial(id, pageNum) {
        this.$ajax.post('/etv/findAllMaterial.json', qs.stringify({
          id,
          type: 'video',
          pageNum,
          pageSize: this.pageSize,
          filterType: 1
        })).then(res => {
          if (res.data.code === 0) {
            this.number =0
            this.index = 0
            const newItems = res.data.data.materialList;
            this.totalNum = res.data.data.totalNum; // Update total number of items
            newItems.forEach(res => {
              res.checked = false;
            });
            this.materialList = [...this.materialList, ...newItems];
            this.loading = false;
            this.refreshing = false;

            if (this.materialList.length >= this.totalNum) {
              this.finished = true;
            } else {
              this.pageNum++;
            }
          } else {
            this.loading = false;
            this.refreshing = false;

          }
        }).catch(() => {
          this.loading = false;
          this.refreshing = false;

        });
      },
    },
    destroyed() {
      this.materialList = []
    },
    checkBeforeUpload() {
      if (this.number !== 0) {
        this.$toast(this.$t('append_field.cancelAllSelections'));
        return false; // 阻止文件读取
      }
      // 这里可以添加你的文件验证逻辑
      return true; // 允许文件读取
    },

  }
</script>

<style lang="scss">
  @import "../../public/static/css/app";
  .updata {
    //background: #ffffff;
    //width: 90%;
    //border-radius: 5px;
    //padding: 20px;
    //box-sizing: border-box;

    .updata-title {
      height: 25px;
      margin-bottom: 10px;
      font-weight: 700;
    }

    .updata-item {
      display: block;
      width: 100%; /* 使文本占满按钮宽度 */
      white-space: nowrap; /* 确保文本在一行显示 */
      overflow: hidden; /* 超出容器部分隐藏 */
      text-overflow: ellipsis; /* 使用省略号表示文本被截断 */

    }
    .updata-item-right {
      height: 20px;
      display: flex;
      align-items: center;
      color: #8c8c8c;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .addVideo {
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 55;
    background: #ffffff;
    .select-groupings{
      height: calc(100% - 380px);
    }
    .van-dialog__content{
      height: calc(100% - 40px - 60px);
      overflow-y: auto;
    }
    .dialog-content {
      margin: 45px 16px;
      display: flex;
      flex-direction: column;
      word-wrap: break-word;
      white-space: normal;
      overflow-wrap: break-word;
    }
    .dialog-content span {
      margin-bottom: 8px;
      word-break: break-word;
    }
    .van-icon{
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .full-name{
      margin: 0 10px;
      position: absolute;
      top: 60px;
      left: 0;
      right: 0;
      height: 30px;
      line-height: 30px;
      span{
        width: 100%;
        display: block;
        white-space: nowrap; /* 确保文本在一行显示 */
        overflow: hidden; /* 超出容器部分隐藏 */
        text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
        font-size: 14px;
        color: #333;
      }
    }
    .materiallist {
      width: 100%;
      padding: 2px;
      box-sizing: border-box;
      position: absolute;
      left: 0;
      top: 90px;
      bottom: 60px;
      overflow: auto;

      .content {
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        justify-content: flex-start;
      }
     /* .up_loading{
        padding: 20px 32px 30px 28px;
        margin-top: 5px;
      }*/
      .photo {
        box-sizing: border-box;
        padding: 2px;

        .van-uploader__upload-icon {
          font-size: 48px;
        }

        .van-uploader {
          width: 100%;
          height: 100%;
          border: none;

          .van-uploader__wrapper {
            width: inherit;
            height: inherit;

            .van-uploader__upload {
              width: inherit;
              height: inherit;
              margin: 0 !important;
              border: none;
            }
          }
        }

        .updata-centnt {
          width: 100%;
          height: 100%;
          border-radius: 5px;

          .updata {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            background: #ffffff;

            .updata-img {
              width: 40%;
              height: 40%;
              margin-bottom: 10px;
            }
          }
        }

      }


      .materia-item {
        position: relative;
        padding: 2px;
        box-sizing: border-box;

        .checkbox {
          position: absolute;
          top: 1px;
          right: 5px;
          display: flex;
          justify-content: center;
          align-items: center;

          checkbox {
            width: 25.42px;
            height: 25.42px;
          }
        }

        .image {
          width: 100%;
          height: 100%;
        }
        .audit-name{
          display: inline-block;
          white-space: nowrap; /* 确保文本在一行显示 */
          overflow: hidden; /* 超出容器部分隐藏 */
          text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
          width: 100%;
          line-height: 22px; /* 设置与高度相同的行高 */
          font-size: 16px;
          color: #131212;
        }
      }
    }

    .grouping {
      display: flex;
      width: 100%;
      position: fixed;
      top: 0;
      left: 0;
      height: 60px;
      gap: 10px; /* 按钮之间的间隔 */
      align-items: center;
      justify-content: flex-start;
      border-bottom: 1px solid $uni-border-bottom-color;
      overflow-x: auto; /* 水平滚动 */
      .terminal-btn{
        flex: 1 1 auto; /* 自适应宽度 */
        white-space: nowrap; /* 防止文字换行 */
        background-color: white;
        color: black;
        border: 1px solid #ddd; /* 可选：添加边框以便更清晰地看到按钮 */
      }
      .van-button{
        width: 200px !important;
      }
      .van-button__text{
        display: block;
        max-width: 100%;
        white-space: nowrap; /* 确保文本在一行显示 */
        overflow: hidden; /* 超出容器部分隐藏 */
        text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
      }
      .selected {
        background-color: #006EFF ;
        color: white;
      }
    }
    .btns {
      display: flex;
      position: fixed;
      bottom: 0;
      width: 100%; /* 确保容器宽度充满屏幕 */
      height: 60px;
      justify-content: space-between; /* 子元素平均分布在容器中 */
      align-items: center; /* 垂直居中对齐 */
      background-color: white; /* 可选：为了清晰显示 */
      box-sizing: border-box; /* 防止边框或内边距影响布局 */
      padding: 0 15px; /* 可选：给两侧添加一些内边距 */
    }
    .btns > * {

      text-align: center; /* 文本居中对齐 */
    }
    .van-sidebar {
      width: 100%;
    }
  }


</style>
